import {pathHelpContentFile} from '../../../utils/path';
import {CONTENT_TYPE_TEXT, CONTENT_TYPE_IMAGE, CONTENT_CATEGORY_CLIENT} from '../../constants';

export default {
  id: 'LIST_CLIENT',
  title: 'Perché non vedo i miei clienti nella lista dei clienti?',
  description: '',
  categories: [CONTENT_CATEGORY_CLIENT],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Hai controllato nella scheda «Inviti inviati»?'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_LIST_CLIENT/IT_LIST_CLIENT_1.png`
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Qui ci sono gli inviti inviati, in attesa di accettazione del vostro cliente.'
  },
  {
    type: CONTENT_TYPE_TEXT,
    value: 'Se non hanno risposto alla vostra richiesta, avete la possibilità di rilanciarli dopo 15 giorni cliccando su «Invitare di nuovo».'
  },
  {
    type: CONTENT_TYPE_IMAGE,
    value: `${pathHelpContentFile}it/IT_LIST_CLIENT/IT_LIST_CLIENT_2.png`
  }]
};
